import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { FormContainer, useForm } from 'react-hook-form-mui';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import InputLabel from '@mui/material/InputLabel';
import { APIContext } from '../../Contexts/APIContext';
import ValidatedTextField from '../../Utilities/Forms/ValidatedTextField';
import { useContext, useEffect, useState } from 'react';
import DropDownViewModel from '../../Utilities/ViewModels/DropDownViewModel';
import ValidatedSelectElement from '../../Utilities/Forms/ValidatedSelectElement';
import CreateEditOrganisationUserViewModel from './ViewModels/CreateEditOrganisationUserViewModel';

interface IProps {
    open: boolean;
    onClose: (refresh: boolean) => void;
    orgId: string;
    role: "Choose Role" | "Manager" | "Member"
    siteId?: string;
}

export default function AddOrgAdminDialog(props: IProps) {
    const { get, post, showMessage, loading } = useContext(APIContext);
    const { open, onClose, role, siteId } = props;
    const [roles, setRoles] = useState<DropDownViewModel[]>([]);
    const [sites, setSites] = useState<DropDownViewModel[]>([]);


    const formContext = useForm<CreateEditOrganisationUserViewModel>({
        defaultValues: new CreateEditOrganisationUserViewModel(props.orgId, siteId),
    });
    const { reset } = formContext;

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        get("AdminUser", `GetRolesDropdown?level=org`, setRoles);
        get("AdminUser", `GetSitesDropdown?orgId=${props.orgId}`, setSites);

    }

    const onSucess = () => {
        onClose(true);
        reset(new CreateEditOrganisationUserViewModel(props.orgId, siteId))
        showMessage('success', "User added successfully");
    }

    const submit = async (form: any) => {
        if (role !== "Choose Role") {
            form.role = roles.find(r => r.label === role)?.id;
        }
        await post("AdminUser", `CreateUser`, form, onSucess);
    }

    const checkCloseDialog = async () => {
        onClose(false);
        reset(new CreateEditOrganisationUserViewModel(props.orgId, siteId))
    }

    return (
        <Dialog
            open={open}
            onClose={() => checkCloseDialog()}
            maxWidth="xs"
            fullWidth
        >
            <FormContainer
                onSuccess={submit}
                formContext={formContext}
            >
                <DialogTitle>Add User</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12 }}>
                            <InputLabel shrink>Email</InputLabel>
                            <ValidatedTextField name="email" disabled={loading} />
                        </Grid>
                        {role === "Choose Role" &&
                            <Grid size={{ xs: 12 }}>
                                <InputLabel shrink>Role</InputLabel>
                                <ValidatedSelectElement name="role" options={roles} disabled={loading} />
                            </Grid>
                        }
                        <Grid size={12}>
                            <InputLabel shrink>Site</InputLabel>
                            <ValidatedSelectElement name="siteId" options={sites} disabled={loading} />
                        </Grid>
                    </Grid>
                    <DialogActions>
                        <Button disabled={loading} variant="contained" type="submit">Add</Button>
                        <Button disabled={loading} onClick={() => checkCloseDialog()} color="error">Cancel</Button>
                    </DialogActions>
                </DialogContent>
            </FormContainer>
        </Dialog >
    );
}